import { storage } from 'common/storage';

export const customConfig = () => {
  const customConfig = storage.session.getItem('customConfig');

  return customConfig ?? {};
};
